module.exports = __webpack_public_path__ + "static/media/icon_development_on.07c97f02.png";